import { IPartner } from "~/entity/Partners";
import { IPartnersFilterForm } from "~/pages/Partners/PartnersFilter";
import {
  matchesPeriod,
  matchesSelect,
  matchesText,
} from "~/shared/lib/filterHelpers";

export const filterPartners = (
  items: IPartner[],
  filter: IPartnersFilterForm,
): IPartner[] => {
  return items.filter((item) => {
    if (filter.id && !item.id.includes(filter.id)) return false;
    if (!matchesText(item.name, filter.name)) return false;
    if (!matchesText(item.inn, filter.inn)) return false;
    if (!matchesText(item.author, filter.author)) return false;

    if (!matchesSelect(item.status, filter.status)) return false;
    if (!matchesText(item.country, filter.country?.value ?? undefined))
      return false;
    if (!matchesText(item.fo, filter.fo?.value ?? undefined)) return false;
    if (!matchesText(item.region, filter.region?.value ?? undefined))
      return false;
    if (!matchesText(item.city, filter.city?.value ?? undefined)) return false;

    if (
      !matchesPeriod(item.createdAt, {
        startFrom: filter.createdFrom,
        startTo: filter.createdTo,
      })
    )
      return false;

    return true;
  });
};
